var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.DISPLAY_ITEM_TEXT[`${_vm.displayChart.chartId}`]))])]),_c('apexchart',{ref:"dataChart",staticClass:"access-chart",attrs:{"type":"bar","height":"350","options":_vm.options,"series":_vm.displayChart.dataSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }